<script setup lang="ts">
  import type { Organization } from '@/types/organization'
  import { FormInput } from '@logistiek-zonder-papier/lzp-library'
  import AddressForm from '@/components/AddressForm.vue'
  import { getAddressFromOrganization } from '@/utils/organization'

  defineProps<{
    organization: Organization
  }>()
</script>

<template>
  <div>
    <FormInput :model-value="organization?.organisatieNaam" label="Organisatienaam" disabled />
    <AddressForm :address="getAddressFromOrganization(organization!)" />
    <FormInput :model-value="organization?.organisatieNummer" label="Organisatienummer" disabled />
  </div>
</template>

<style></style>
